import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=d722d968&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=d722d968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d722d968",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d722d968')) {
      api.createRecord('d722d968', component.options)
    } else {
      api.reload('d722d968', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=d722d968&scoped=true&", function () {
      api.rerender('d722d968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4ZzvH23a4DZkG/JS/comp/DocBox.vue"
export default component.exports